import { createFileRoute, notFound } from "@tanstack/react-router";
import { BmiPageShell } from "@/components/bmi/BmiPageShell";
import { generateBmi } from "@/lib/bmi/generator";
import { parseAgeSlug } from "@/lib/bmi/clusters";
import { leafHead } from "@/lib/seo/leaf-head";
import { bmiPageScripts } from "@/lib/bmi/schemas";

export const Route = createFileRoute("/bmi-calculator-for-women-{$age}-years-old")({
  loader: ({ params }) => {
    const age = parseAgeSlug((params as { age: string }).age, 18, 67);
    if (age === null) throw notFound();
    return generateBmi({ cluster: "B", age });
  },
  head: ({ loaderData }) => {
    if (!loaderData) return { meta: [{ title: "Not found" }, { name: "robots", content: "noindex" }] };
    return leafHead({
      path: loaderData.path,
      title: loaderData.meta.title,
      description: loaderData.meta.description,
      ogType: "article",
      scripts: bmiPageScripts(loaderData),
    });
  },
  component: Comp,
  notFoundComponent: () => (
    <div className="mx-auto max-w-lg p-8 text-center">
      <h1 className="text-2xl font-bold">BMI page not found</h1>
      <p className="mt-2 text-muted-foreground">Valid ages are 18–67 for this variant.</p>
    </div>
  ),
  errorComponent: () => (
    <div className="mx-auto max-w-lg p-8 text-center"><h1 className="text-2xl font-bold">Something went wrong</h1></div>
  ),
});

function Comp() {
  const data = Route.useLoaderData();
  return <BmiPageShell data={data} />;
}